import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthorizeControlService } from 'pr1-ui-components';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-edit-dates-dialog',
  templateUrl: './edit-dates-dialog.component.html',
  styleUrls: ['./edit-dates-dialog.component.scss']
})
export class EditDatesDialogComponent implements OnInit {
  formGroup!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private matDialogRef: MatDialogRef<EditDatesDialogComponent>,
    private authorizationService: AuthorizeControlService,
    @Inject(MAT_DIALOG_DATA) public data: { defaultStartDate: string, defaultEndDate: string }
  ) { }


  ngOnInit() {
    const startDate = this.data?.defaultStartDate ? dayjs(this.data.defaultStartDate, 'MM/DD/YYYY').toDate() : null;
    const endDate = this.data?.defaultEndDate ? dayjs(this.data.defaultEndDate, 'MM/DD/YYYY').toDate() : null;

    this.formGroup = this.fb.group({
      StartDate: [startDate, Validators.required],
      EndDate: [endDate, Validators.required]
    }, { validators: this.dateRangeValidator });

    this.setFormAccess();
  }

  // Group-level validator to ensure EndDate >= StartDate
  dateRangeValidator(group: AbstractControl) {
    const start = group.get('StartDate')?.value;
    const end = group.get('EndDate')?.value;
    if (start && end && end < start) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  updateDates() {
    if (this.formGroup.invalid) return;
    this.matDialogRef.close(this.formGroup.value);
  }

  canEdit(): boolean {
    return this.authorizationService.checkAccess('edit||offermang');
  }

  setFormAccess(): void {
    if (this.canEdit()) {
      if (this.formGroup.disabled) {
        this.formGroup.enable();
      }
    } else {
      if (this.formGroup.enabled) {
        this.formGroup.disable();
      }
    }
  }

  get startDate() {
    return this.formGroup.get('StartDate');
  }

  get endDate() {
    return this.formGroup.get('EndDate');
  }
}
